export * from "./api";
export * from "./contacts";
export * from "./localization";
export * from "./map";
export * from './style'


export const INFO_BLOCK_TYPES = {
    MAIN_PAGE: "MAIN_PAGE",

}